module.exports = __webpack_public_path__ + "img/icon5.f172078e.png";